import { useLocation, useParams } from "react-router-dom";

interface SpaceParams {
  eventSlug?: string;
  spaceSlug?: string;
}

const SPACE_QUERY_PARAM_KEYS = [
  "pastEvents",
  "status",
  "topics",
  "sort",
] as const;
type SpaceQueryParamKey = (typeof SPACE_QUERY_PARAM_KEYS)[number];

export const useSpaceParams = () => {
  const { spaceSlug, eventSlug } = useParams<SpaceParams>() || {};
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const queryStringParams: Partial<Record<SpaceQueryParamKey, string>> = {};
  SPACE_QUERY_PARAM_KEYS.forEach(key => {
    const value = urlSearchParams.get(key);
    if (value) {
      queryStringParams[key] = value;
    }
  });
  return {
    spaceSlug,
    eventSlug,
    ...queryStringParams,
  };
};
